import React from 'react';
import PropTypes from 'prop-types';

import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';

import { LinkStyle } from 'libs/editor/styles';

class LinkifiedLinkNode extends React.Component {
  render() {
    const { attributes, node, children } = this.props;
    const { data } = node;
    const url = data.get('url');

    return (
      <LinkStyle href={url} target='_blank' rel='noopener' {...attributes}>
        {children}
      </LinkStyle>
    );
  }
}

LinkifiedLinkNode.propTypes = {
  node: PropTypes.object,
  children: PropTypes.node,
  attributes: PropTypes.object,
};

const type = 'linkified-link';

export function LinkifiedLink() {
  return {
    button: {
      elementType: 'inline',
      type,
    },
    plugins: [RenderNode(type, props => <LinkifiedLinkNode {...props} />)],
  };
}
